
import { SpecialEvent } from '../../types/specialEvent';
import { skills } from '../skills';

export const bitcoinHalvingEvent: SpecialEvent = {
  id: 'bitcoin-halving',
  title: 'Bitcoin Halving',
  description: 'The Bitcoin network has reached its scheduled halving, reducing mining rewards by 50%. How will you adapt your operations?',
  type: 'market',
  triggerYears: [4, 8, 12, 16], // Halvings occur roughly every 4 years
  options: [
    {
      text: 'Focus on efficiency optimization',
      outcome: 'You increase your operational efficiency to offset the reduced rewards.',
      roleSpecificOutcome: [
        {
          roleId: 'engineer',
          outcome: 'As an engineer, your firmware optimizations achieve exceptional efficiency gains, more than offsetting the halving impact.',
          kpiEffects: {
            efficiency: 5,
            profitMargin: 2
          },
          experienceGain: 30
        },
        {
          roleId: 'energy',
          outcome: 'Your energy expertise allows you to significantly reduce costs, helping maintain profitability despite lower rewards.',
          kpiEffects: {
            energyCost: -0.005,
            profitMargin: 1.5
          },
          experienceGain: 25
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'custom-firmware-development',
          outcome: 'Your custom firmware development skills allow you to extract maximum performance from your hardware.',
          kpiEffects: {
            efficiency: 7,
            profitMargin: 3
          },
          experienceGain: 35
        }
      ],
      kpiEffects: {
        efficiency: 3,
        profitMargin: -2,
        energyCost: -0.001
      },
      experienceGain: 20
    },
    {
      text: 'Scale up operations',
      outcome: 'You invest in more hardware to maintain revenue despite lower per-unit rewards.',
      roleSpecificOutcome: [
        {
          roleId: 'entrepreneur',
          outcome: 'Your business acumen allows you to scale operations with exceptional capital efficiency.',
          kpiEffects: {
            profitMargin: 3,
            uptime: 1
          },
          experienceGain: 30
        },
        {
          roleId: 'operations',
          outcome: 'Your operational expertise allows you to scale with minimal disruption to existing systems.',
          kpiEffects: {
            uptime: 2,
            efficiency: 1.5
          },
          experienceGain: 25
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'strategic-planning',
          outcome: 'Your strategic planning skills enable optimal resource allocation during expansion.',
          kpiEffects: {
            profitMargin: 4,
            efficiency: 2
          },
          experienceGain: 30
        }
      ],
      kpiEffects: {
        uptime: -1,
        profitMargin: -3,
        efficiency: 1
      },
      experienceGain: 20,
      skillUnlock: skills.find(s => s.id === 'supply-chain')
    },
    {
      text: 'Diversify into other cryptocurrencies',
      outcome: 'You allocate some resources to mine alternative cryptocurrencies.',
      roleSpecificOutcome: [
        {
          roleId: 'technician',
          outcome: 'Your technical expertise allows you to quickly adapt hardware for multi-coin mining.',
          kpiEffects: {
            efficiency: 3,
            uptime: 2
          },
          experienceGain: 25
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'market-analysis',
          outcome: 'Your market analysis skills help you select the most profitable alternative coins to mine.',
          kpiEffects: {
            profitMargin: 5,
            efficiency: 1
          },
          experienceGain: 30
        }
      ],
      kpiEffects: {
        profitMargin: 1,
        efficiency: -2,
        uptime: -1
      },
      experienceGain: 15
    }
  ]
};
